import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { order } from "../services/api";

// Thunk to fetch vendors data
export const fetchOrders = createAsyncThunk("order/fetchOrder", async () => {
  const response = await order();
  return response;
});

const orderSlice = createSlice({
  name: "orders",
  initialState: {
    data: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default orderSlice.reducer;
